import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { REVIEWS } from "../lib/site";

const Reviews = () => {
  const { t } = useLang();
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-36 bg-[#0a0a0a] border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.06),transparent_70%)]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="label-eyebrow text-gold">{t.reviews.eyebrow}</span>
            </div>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              {t.reviews.title}
            </h2>
          </div>
          <div className="flex items-center gap-3" data-testid="reviews-summary">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="h-5 w-5 fill-gold text-gold"
                  strokeWidth={0}
                />
              ))}
            </div>
            <span className="font-display text-2xl text-white">5.0</span>
            <span className="label-eyebrow text-white/40">/ Google</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`review-card-${i}`}
              className="relative bg-black/60 backdrop-blur-xl border border-white/10 rounded-sm p-7 hover:border-gold/40 transition-all group"
            >
              <Quote className="h-7 w-7 text-gold/40 mb-4 group-hover:text-gold/70 transition-colors" />
              <div className="flex mb-3">
                {[...Array(r.rating)].map((_, j) => (
                  <Star
                    key={j}
                    className="h-4 w-4 fill-gold text-gold"
                    strokeWidth={0}
                  />
                ))}
              </div>
              <p className="text-white/80 text-sm leading-relaxed">
                "{r.text}"
              </p>
              <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
                <span className="label-eyebrow text-white/50">{r.author}</span>
                <span className="text-[10px] tracking-widest text-white/30 uppercase">
                  Google
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
